export const CRT_OPTIONS = [
    {
        id: '1',
        descricao: '1 - SIMPLES NACIONAL',
    },
    {
        id: '2',
        descricao: '2 - SIMPLES NACIONAL — EXCESSO DE SUBLIMITE',
    },
    {
        id: '3',
        descricao: '3 - REGIME NORMAL',
    },
    {
        id: '4',
        descricao: '4 - SIMPLES NACIONAL — MEI',
    },
];

export const ORIGEM_MERCADORIA_OPTIONS = [
    {
        id: '0',
        descricao: '0 - Nacional, exceto códigos 3, 4, 5 e 8',
    },
    {
        id: '1',
        descricao: '1 - Estrangeira, importação direta',
    },
    {
        id: '2',
        descricao: '2 - Estrangeira, adquirida no mercado interno',
    },
    {
        id: '3',
        descricao: '3 - Nacional, conteúdo de importação superior a 40% e até 70%',
    },
    {
        id: '4',
        descricao: '4 - Nacional, produzida conforme processo produtivo básico',
    },
    {
        id: '5',
        descricao: '5 - Nacional, conteúdo de importação até 40%',
    },
    {
        id: '6',
        descricao: '6 - Estrangeira, importação direta, sem similar nacional',
    },
    {
        id: '7',
        descricao: '7 - Estrangeira, mercado interno, sem similar nacional',
    },
    {
        id: '8',
        descricao: '8 - Nacional, conteúdo de importação superior a 70%',
    },
];
